// Merged hi dictionary. Each area file is owned by one part of the app; later files win on a duplicate key.
import core from './core.js';
import shell from './shell.js';
import fieldA from './fieldA.js';
import fieldB from './fieldB.js';
import apiErrors from './apiErrors.js';

export default { ...core, ...shell, ...fieldA, ...fieldB, ...apiErrors };
